module.exports = __webpack_public_path__ + "static/media/isotop_3.d87afc83.jpeg";